// API color may be null. Keep the DTO untouched; derive a presentation color by code.
const colors = {
  infinix: "#192923",
  iqoo: "#25252c",
  itel: "#bd2447",
  poco: "#88701a",
  realme: "#93691d",
  samsung: "#253663",
  tecno: "#363e97",
  vivo: "#473798",
};
const logoColors = {
  infinix: "#152a22",
  iqoo: "#21212b",
  itel: "#ec174b",
  poco: "#8b7100",
  realme: "#9d7700",
  samsung: "#174991",
  tecno: "#1474df",
  vivo: "#526be1",
};
export function brandCode(brand) {
  return String(brand?.code || brand?.id || "")
    .toLowerCase()
    .replace(/[^a-z0-9_-]/g, "");
}
export function getBrandColor(brand) {
  return brand?.color || colors[brandCode(brand)] || "#334155";
}
export function getBrandLogoColor(brand) {
  return (
    brand?.logoColor ||
    brand?.color ||
    logoColors[brandCode(brand)] ||
    "#334155"
  );
}
